import setListingAttributesDisclosureCategory from '../../utils/disclosureCategories/disclosureCategories';

export function enhanceListings(state = {}, reducerData = {}) {
  const {listings = {}, event = {}} = state || {};
  if (!event.loading && event.seatTraits) {
    const {data = []} = reducerData || {};
    const {seatTraits = []} = event;

    const enhancedListings = setListingAttributesDisclosureCategory(data, seatTraits);

    return {
      listings: {...listings, ...reducerData, data: enhancedListings},
    };
  }

  return {listings: {...listings, ...reducerData}};
}
